import React from 'react'
import { twMerge } from 'tailwind-merge'

export interface ActionMenuButtonProps {
  label: string
  onClick: () => void
  className?: string
  iconBefore?: () => React.ReactNode
  iconAfter?: () => React.ReactNode
}

export const ActionMenuButton: React.FC<ActionMenuButtonProps> = ({
  label,
  onClick,
  className = '',
  iconBefore,
  iconAfter,
}) => {
  return (
    <button
      type="button"
      className={twMerge(
        'flex cursor-pointer items-center gap-1.5 px-3 py-2 transition-all duration-150',
        'bg-bgPrimaryBase hover:bg-bgSecondary active:bg-bgSecondary',
        '[&>svg]:h-5 [&>svg]:w-5',
        '[&>svg>path]:stroke-iconTertiary',
        className,
      )}
      onClick={onClick}
    >
      {iconBefore?.()}
      <span className={twMerge('text-M text-textPrimary', 'select-none')}>
        {label}
      </span>
      {iconAfter?.()}
    </button>
  )
}
